import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b497c5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "processingItem" }
const _hoisted_2 = { class: "processingItemInner" }
const _hoisted_3 = { class: "processingItemInnerText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_loading, {
        type: "circular",
        class: "van-button__loading"
      }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.caption), 1)
    ])
  ]))
}